import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 커뮤니티 로그인 - 아이디 찾기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { getApiLangState } from "../../../../recoil/langState";
import { findId } from "../../../../recoil/userState";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { useTrans } from "../../../../utils/langs/useTrans";
export default function CmmFindIdPop(props) {
    const t = useTrans();
    //recoil
    const setFindId = useSetRecoilState(findId);
    const apiLang = useRecoilValue(getApiLangState);
    //
    const [userName, setUserName] = useState(""); //bsKim
    const [userPhone, setUserPhone] = useState(""); //01000000001
    const [errorList, setErrorList] = useState([]);
    const [resUserNameMsg, setUserNameMsg] = useState("");
    const [display, setDisplay] = useState(false);
    const { data: data, error, isLoading, reload, run, } = useAsync({
        deferFn: HTTPUTIL.Http,
        httpMethod: "GET",
        appPath: "/user/id",
        appQuery: {
            userName: userName,
            phoneNumber: userPhone,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == 200) {
                setUserNameMsg(data.body.userId);
                setDisplay(true);
            }
            else {
                setErrorList(data.errorList);
            }
        }
    }, [data]);
    // 이름
    function handleSetUserName(val) {
        setErrorList(errorList.filter((err) => err.field !== "userName"));
        setUserName(val);
    }
    // 핸드폰 번호
    function handleSetPhoneNumber(val) {
        setErrorList(errorList.filter((err) => err.field !== "phoneNumber"));
        setUserPhone(val);
    }
    function Close(id) {
        setUserName("");
        setUserPhone("");
        setErrorList([]);
        setUserNameMsg("");
        setDisplay(false);
        CUTIL.jsclose_Popup(id);
    }
    function FindPwPop(e, id) {
        Close(id);
        CUTIL.jsopen_Popup(e);
        setFindId(resUserNameMsg);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "cmm-findId", className: "popup-layer js-layer hidden inner-popup popup-type1 pop-login w350" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.아이디찾기") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("cmm-findId") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body find-idpw" }, { children: [_jsx("form", Object.assign({ action: "", method: "", name: "popfindId", style: { display: display ? "none" : "block" } }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "username", className: "star" }, { children: t("라벨.이름") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "username", placeholder: t("라벨.이름입력"), value: userName, className: errorList.filter((err) => err.field === "userName").length > 0 ? "input-error" : "", onChange: (e) => handleSetUserName(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "userName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userphone", className: "star" }, { children: t("라벨.연락처") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "tel", id: "userphone", placeholder: t("라벨.숫자만입력"), value: userPhone, className: errorList.filter((err) => err.field === "phoneNumber").length > 0 ? "input-error" : "", onChange: (e) => handleSetPhoneNumber(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "phoneNumber").map((err) => err.msg) }))] }))] })] })) })), _jsxs("div", Object.assign({ className: "complete-txt", style: { display: !display ? "none" : "block" } }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.아이디찾기완료") })), _jsx("p", { children: resUserNameMsg })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsxs("button", Object.assign({ type: "button", className: "js-close bg-gray", onClick: (e) => Close("cmm-findId") }, { children: [" ", _jsx("span", { children: t("라벨.취소") })] })), !display ? (_jsx("button", Object.assign({ type: "button", onClick: run }, { children: _jsx("span", { children: t("라벨.찾기") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "js-open", "data-pop": "cmm-findPw", onClick: (e) => FindPwPop(e, "cmm-findId") }, { children: _jsx("span", { children: t("라벨.비밀번호찾기") }) })))] }))] })) }));
}
